/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApprovalConfigurationDto, ResolveConfigurationPayload } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiApprovalConfigurationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-approval-configuration-controller
   * @name ResolveConfiguration
   * @request POST:/api/v1/approval-configuration/request
   */
  resolveConfiguration = (data: ResolveConfigurationPayload, params: RequestParams = {}) =>
    this.http.request<ApprovalConfigurationDto, any>({
      path: `/v1/approval-configuration/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static resolveConfigurationPath = '/v1/approval-configuration/request'
  static resolveConfigurationMethod = 'POST'
}
